import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

import { IconComponent } from '../../../../../shared/icon/icon';

/**
 * The encouragement intercept between Step 2 and the summary (master document:
 * "Unlock more funding options").
 *
 * Shown by the wizard only when the applicant leaves Step 2 with NO age
 * analysis and NO financial statements server-confirmed; with either present
 * the wizard goes straight to the summary and this never renders. It is
 * Step-adjacent, not a step: the stepper keeps Step 2 active behind it.
 *
 * 🚨 No amount, no "may unlock R…", no size element of any kind — `§A12` P1 (the
 * gate is open), `§A12.4` (the Debtors Finance figure is undetermined) and
 * `UI-DA-58-01` (where sizing has not run, no size element at all).
 *
 * The master's footnote *"You can also add this information later from your
 * dashboard"* is present because the path exists: a SUBMITTED enquiry accepts
 * documents, add-only (PO ruling 2026-09-22; the add-documents page).
 *
 * Dumb by design: two outputs, no state. The wizard owns where each lands.
 */
@Component({
  selector: 'app-encourage-intercept',
  imports: [MatButtonModule, IconComponent],
  templateUrl: './encourage-intercept.html',
  styleUrl: './encourage-intercept.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EncourageInterceptComponent {
  /** Primary — carry on to the summary with bank data only. */
  readonly submitWithout = output<void>();
  /** Secondary — back to Step 2 to add financial documents. */
  readonly uploadFinancials = output<void>();
}
